(function () {
  var checkjQuery = function () {
    if (window.jQuery) {
      function addProductToCart(btnClicked) {
        // e.preventDefault();
        console.log(btnClicked);

        $(btnClicked)
          .parent(".buy-buttons_head")
          .parent(".buy_btn_plus_qty_selector-head")
          .siblings(".buy-btn-prev")
          .find(".product-form__buttons")
          .children("button")
          .trigger("click");
      }

      window.SLIDECART_UPDATED = function (cart) {
        $(".header__icon--cart").load(" .header__icon--cart");
        let subTotal = document.querySelector('.slidecart-subtotal');
        if (subTotal) {
          subTotal.innerHTML = `$${(cart.items_subtotal_price / 100).toFixed(2)}`;
        }
        rewardBarCustomUpdate()
      };

      function rewardBarCustom() {
        if( window.rewardBarString.enable ) {
          if( document.querySelector('.rewardBarCustom') ) return;
          const itemsElement = document.querySelector(".slidecarthq .items");
          if (itemsElement) {
            const rewardBar = document.createElement("div");
            const totalValue = Array.from(document.querySelectorAll('#slidecarthq .items .item input')).map(input => parseFloat(input.value) || 0).reduce((acc, value) => acc + value, 0);
            const percentageNumber = window.rewardBarString.steps == 2 ? 50 : 35;
            const numberItems = totalValue > 2 ? 100 : totalValue * percentageNumber;
            rewardBar.className = `rewardBarCustom steps--${window.rewardBarString.steps}`;
            rewardBar.innerHTML = `
              <div class='rewardBarCustom__inner'>
                <p class='rewardBarCustom__message'>${window.rewardBarString.message_1}</p>
                <p class='rewardBarCustom__message'>${window.rewardBarString.message_2}</p>
                <div class='rewardBarCustom__barCover'>
                  <div class='rewardBarCustom__bar'>
                    <div class='rewardBarCustom__barPogress' style='width: ${numberItems}%'></div>
                  </div>
                  <span class='rewardBarCustom__point point1 ${totalValue >= 1? 'active':''}' data-message='${window.rewardBarString.point_1}'></span>
                  <span class='rewardBarCustom__point point2 ${totalValue >= 2? 'active':''}' data-message='${window.rewardBarString.point_2}'></span>
                  <span class='rewardBarCustom__point point3 ${totalValue >= 3? 'active':''}' data-message='${window.rewardBarString.point_3}'></span>
                </div>
              </div>
            `;
            
            itemsElement.parentNode.insertBefore(rewardBar, itemsElement);
          }
        }
      }
      function updateProgress(width) {
        requestAnimationFrame(() => {
            document.querySelector('.rewardBarCustom__barPogress').style.width = `${width}%`;
        });
      };
      function rewardBarCustomUpdate() {
        if ( document.querySelector('.rewardBarCustom')) {
          const totalValue = Array.from(document.querySelectorAll('#slidecarthq .items .item input')).map(input => parseFloat(input.value) || 0).reduce((acc, value) => acc + value, 0);
          if (totalValue == 0) {
            document.querySelector('.rewardBarCustom').remove();
            return;
          }
          let count = 1 // index starts from 1 not 0
          document.querySelectorAll('.rewardBarCustom__point').forEach(point => {
            point.classList.remove('active');
            if( totalValue >= count ) {
              point.classList.add('active');
            }
            count++;
          });
          const percentageNumber = window.rewardBarString.steps == 2 ? 50 : 35;
          const numberItems = totalValue > 2 ? 100 : totalValue * percentageNumber;
          updateProgress(numberItems)
        } else {
          rewardBarCustom();
        }
      }

      $(document).ready(function () {
        $('#slidecarthq header.header').addClass('headerOveride');

        /* PDP 4 Tabs Logic Start */
        const tabHeaders = document.querySelectorAll(".tab-header");
        const tabs = document.querySelectorAll(".tab");
      
        tabHeaders.forEach((header) => {
          header.addEventListener("click", function () {
            tabHeaders.forEach((h) => h.classList.remove("active"));
            tabs.forEach((t) => {
              t.classList.remove("active");
              t.style.opacity = 0;
            });
            this.classList.add("active");
            const targetTab = this.getAttribute("data-tab");
            const activeTab = document.querySelector(`.tab[data-tab='${targetTab}']`);
            activeTab.classList.add("active");
            setTimeout(() => {activeTab.style.opacity = 1;}, 50);
          });
        });


        const faqItems = document.querySelectorAll('.faq-question');
        faqItems.forEach(button => {
          button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            const answer = document.getElementById(button.getAttribute('aria-controls'));

            button.setAttribute('aria-expanded', !expanded);
            answer.hidden = expanded;
          });
        });
        
        /* PDP 4 Tabs Logic End */

        rewardBarCustom();

        let input;
        let variant_id;
        setTimeout(() => {
          $('#slidecarthq header.header').addClass('headerOveride');
          
          $(".header__icon--cart").click(function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.SLIDECART_OPEN && window.SLIDECART_OPEN();

            if (localStorage.getItem("bundle") == "false") {
              $(".quantity-selector").show();
            } else {
              // $(".quantity-selector").hide();
              $("button.remove").click(function (e) {
                e.preventDefault();
                localStorage.removeItem("bundle");
                fetch('/cart/clear.js', { method: 'POST' })
                  .then(() => {
                    if (window.SLIDECART_UPDATE !== 'undefined') {
                      window.SLIDECART_UPDATE();
                    } else {
                      location.href = "/cart";
                    }
                  })
                  .catch(error => {
                    console.error('Error:', error);
                  });
              });
            }
          });
        }, "1000");
        

        $(document).on(
          "click",
          ".conditional-addToCart-button-collection .addToCart-btn",
          function (e) {
            e.preventDefault();

            var input = $(this)
              .parents(".card__information.card__information--style-collection")
              .siblings(".globo-container")
              .find(".swatches-options input[type='radio']:checked")
              .attr("data-variantid");

            var variant_id;
            if (input === undefined) {
              variant_id = $(this).attr("variant-id");
            } else {
              variant_id = input;
            }

            // Call the function to add item to cart
            addItemToCart(variant_id);

            // Uncomment and modify the following lines as needed
            // let quantity = 1;
            // window.SLIDECART_ADD_TO_CART = function({ variant_id, quantity }) {
            //   // Fires whenever an item has been added to cart
            // }
          }
        );

       

        function addItemToCart(variant_id) {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: variant_id,
            },
            dataType: "json",
            success: function (data) {
              window.SLIDECART_UPDATE(data);
              rewardBarCustomUpdate();
              setTimeout(function() {
                window.SLIDECART_OPEN();
              }, 500);
            },
          });
        }


        // hide and show product images
        $(".grid__item .view-more-button.more").click(function (e) {
          e.preventDefault();
          $(this).hide();
          $(this).siblings(".view-more-button.less").show();
          $(this)
            .parent("div")
            .siblings(".product__media-list")
            .removeClass("h-1000");
          console.log("Show more btn clicked!");
        });

        $(".grid__item .view-more-button.less").click(function (e) {
          e.preventDefault();
          $(this).hide();
          $(this).siblings(".view-more-button.more").show();
          $(this)
            .parent("div")
            .siblings(".product__media-list")
            .addClass("h-1000");
          console.log("Show less btn clicked!");
        });

        // $(".preloader-head.onPgaeLoad").hide();

        // Collection read more
        $(
          ".collection--card-wrapper .read-more-collection-description-btn"
        ).click(function () {
          if (
            !$(this)
              .siblings(".read-more-collection-description")
              .is(":visible")
          ) {
            $(".read-more-collection-description").slideUp();
            $(this).siblings(".read-more-collection-description").slideDown();
          } else {
            $(this).siblings(".read-more-collection-description").slideUp();
          }
        });

     
        // announcement-bar-slider
        (function () {
          var checkOwlCarousel = function () {
            if (typeof $.fn.owlCarousel !== 'undefined') {
              // $("#announcement-bar-slider").carousel({
              //   // 4 seconds
              //   interval: 1000 * 3,
              // });
            } else {
              setTimeout(checkOwlCarousel, 100); // Check again after 100ms
            }
          };
          checkOwlCarousel();
        })();

        // FAQs
        $(".faq .content").slideUp();
        $(".faq .minus").hide();
        $(".faq .collapsible").click(function () {
          $(this).children(".plus").toggle();
          $(this).children(".minus").toggle();
          $(this).siblings(".content").slideToggle();
        });

        // hide and show collection description
        $(".collection-desc__next .nextRead").click(function (e) {
          e.preventDefault();
          $(this)
            .parents(".collection-desc__next")
            .siblings(".collection-bottom__description")
            .hide();
          $(this)
            .parents(".collection-desc__next")
            .siblings(".collection-bottom__description-full")
            .slideDown();
          $(this).hide();
        });

        // home page new Arrivals collection slider
        $(
          ".slider-and-video__buttons-wrapper .slider-and-video__button-next, .slider-reviews__buttons-wrapper .slider-reviews__button-next"
        ).click(function () {
          $(
            ".slider-and-video .slider-and-video__slider-wrapper .swiper-wrapper, .slider-reviews .outer-box #H-S"
          ).animate(
            {
              scrollLeft: "+=350px",
            },
            "slow"
          );
        });

        $(
          ".slider-and-video__buttons-wrapper .slider-and-video__button-prev, .slider-reviews__buttons-wrapper .slider-reviews__button-prev"
        ).click(function () {
          $(
            ".slider-and-video .slider-and-video__slider-wrapper .swiper-wrapper, .slider-reviews .outer-box #H-S"
          ).animate(
            {
              scrollLeft: "-=350px",
            },
            "slow"
          );
        });

        // complete the look collection slider
        $(".related-products-wrapper .related-product-btn-next").click(
          function () {
            $(this)
              .parents(".related-products-wrapper")
              .siblings("product-recommendations")
              .children(".product-grid")
              .animate(
                {
                  scrollLeft: "+=360px",
                },
                "slow"
              );
          }
        );

        $(".related-products-wrapper .related-product-btn-prev").click(
          function () {
            $(this)
              .parents(".related-products-wrapper")
              .siblings("product-recommendations")
              .children(".product-grid")
              .animate(
                {
                  scrollLeft: "-=360px",
                },
                "slow"
              );
          }
        );

        // recently viewed collection slider
        $(
          ".recently-viewed-arrow-wrapper .recently-viewed-arrow-btn-next"
        ).click(function () {
          $(this)
            .parents(".recently-viewed-arrow-wrapper")
            .siblings(".recently-viewed.product-grid")
            .animate(
              {
                scrollLeft: "+=360px",
              },
              "slow"
            );
        });

        $(
          ".recently-viewed-arrow-wrapper .recently-viewed-arrow-btn-prev"
        ).click(function () {
          $(this)
            .parents(".recently-viewed-arrow-wrapper")
            .siblings(".recently-viewed.product-grid")
            .animate(
              {
                scrollLeft: "-=360px",
              },
              "slow"
            );
        });

        // open header menu on hover
        let items = document
          .querySelector(".header__inline-menu")
          .querySelectorAll("details");
        enableMenuOpenOnHover(items);

        let headerInlineMenu2 = document.querySelector(".header__inline-menu2");
        if (headerInlineMenu2) {
          let items2 = headerInlineMenu2.querySelectorAll("details");
          enableMenuOpenOnHover(items2);
        } else {
          console.error(
            "Element with class '.header__inline-menu2' not found."
          );
        }

        // let items2 = document.querySelector(".header__inline-menu2").querySelectorAll("details");
        //  enableMenuOpenOnHover(items2);

        function enableMenuOpenOnHover(items) {
          items.forEach((item) => {
            item.addEventListener("mouseover", () => {
              item.setAttribute("open", true);
              item.querySelector("ul").addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
              item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
            });
          });
        }

        function deliveryMessage(selectedVar) {
          let selectedVariant = selectedVar;
          if ($("[data-option-index='1']").length > 0) { 
            selectedVariant = $("[data-option-index='1'] input:checked").parent('.select-option').attr('data-variantid'); 
          }

          if ($('.product-estimated-delivery.show-'+selectedVar).length > 0) {
            $('.product-estimated-delivery--variantShow').show()
            $('.product-estimated-delivery').hide()
            $('.product-estimated-delivery.show-'+selectedVar).show()
            $('.product-estimated-delivery--main').hide()
          } else {
            $('.product-estimated-delivery--main').show()
            $('.product-estimated-delivery--variantShow').hide()
            $('.product-estimated-delivery--variantShow .product-estimated-delivery').hide()
          }
        }

        // Show selected variant -- GLOBO app
        setTimeout(() => {
          let swatchVal;
          let totalSwatches = $(
            ".product__info-wrapper .product__info-container .globo-swatch-list .swatch--gl"
          );
          let selector;
          if (totalSwatches.length > 0) {
            for (let i = 0; i < totalSwatches.length; i++) {
              selector = $(
                ".product__info-wrapper .product__info-container .swatch--gl[data-option-index='" +
                i +
                "'] .select-option input[type='radio']:checked"
              );
              console.log(i);
              swatchVal = $(selector).attr("value");
              // $(selector).click();
              $(
                ".product__info-wrapper .product__info-container .swatch--gl[data-option-index='" +
                i +
                "'] .name-option .name-variant"
              ).text(": " + swatchVal);
              $('.dropdown-button-gsw__value').attr('data-image', swatchVal);
              console.log(swatchVal);
            }
          }

          $('.dropdown-selector .swatch-anchor.swatch-other').click(function () {
            $('.dropdown-button-gsw__value').attr('data-image', $(this).text());
          })

          $(".product__info-wrapper .product__info-container .swatch--gl .select-option input[type='radio']").click(function () {
            setTimeout(() => {
              const params = new URLSearchParams(window.location.search)
              let selectedVar = params.get("variant")
              deliveryMessage(selectedVar);
            }, 300);
          });
          var selectedVariant = $(".product__info-wrapper .product__info-container .swatch--gl .select-option input[type='radio']:checked").parent('.select-option').attr('data-variantid')
          deliveryMessage(selectedVariant);

        }, 4000);

        let counter = 0;
        const checkValueInterval = setInterval(() => {
          counter++;
          if( counter > 50 ) clearInterval(checkValueInterval); // Stop the interval
          const element = document.querySelector('.product__info-wrapper .product__info-container .swatch--gl .dropdown-button-gsw__value');

          if (element && element?.textContent?.trim() !== '') {
            const text = document.querySelector('.product__info-wrapper .product__info-container .swatch--gl .dropdown-button-gsw__value').innerHTML
            document.querySelector('.dropdown-button-gsw__value').setAttribute('data-image',text);
            clearInterval(checkValueInterval); // Stop the interval
          } 
          
          
        }, 300);
      });
    } else {
      setTimeout(checkjQuery, 100);
    }
  };
  checkjQuery();

})();
